import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const LimitExceed = () => {
  const { t } = useTranslation('Vindoc');

  return (
    <section className="mb-6 flex flex-col items-center justify-center">
      <Title level={3} className="uppercase">
        {t("It's time to upgrade")}
      </Title>
      <p className="mb-1">
        {t('You have reached the limit of your current plan')}: {t('10 links per month')}
      </p>
      <p className="mb-1">{t('Please register MAX package to continue using this feature')}</p>
      <p className="mb-1">{t('Thank you!')}</p>
      <Button type="primary" className="mt-6">
        {t('Register now')}
      </Button>
    </section>
  );
};

export default LimitExceed;
